import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'templates'),
  uk: createLocale(uk, 'templates'),
  pl: createLocale(pl, 'templates'),
  ru: createLocale(ru, 'templates'),
  es: createLocale(es, 'templates'),
  uz: createLocale(uz, 'templates'),
  hi: createLocale(hi, 'templates'),
};

export default locales;
